import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

export default function Logout() {
  const { logout, isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && !isLoading) logout();
    else if (!isLoading) {
      navigate("/");
    }
  }, [isAuthenticated, isLoading]);

  return <div>Logging Out...</div>;
}
